<template>
  <div>
    <vxe-grid
      ref="table"
      size="mini"
      cell-class-name="align-top"
      resizable
      auto-resize
      show-footer
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :footer-method="() => footerData"
      :edit-config="{ trigger: 'manual', mode: 'row', enabled: !disabled }"
      :edit-rules="editRules"
      @edit-actived="editActived"
      @edit-closed="editClosed"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:toolbar_btn>
        <slot name="toolbar_btn"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="left"
          >
            <i class="el-icon-edit tool-btn" @click="edit(row)" />
          </el-tooltip>
          <br />
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="left"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)" />
          </el-tooltip>
        </div>
      </template>
      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width:66px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 66px; height: 66px"
            />
          </div>
        </el-image>
      </template>

      <template v-slot:displayName="{ row }">
        <div class="m-0">
          <TableLabel :value="row.goodsName" />
          <TableLabel :value="row.goodsNameEn" />
          <TableLabel
            :label="'SIZE'"
            labelKey="table_label_goodsSize"
            :value="row.goodsSize"
          />
          <TableLabel
            :label="'COLOR'"
            labelKey="table_label_goodsColor"
            :value="`${row.goodsColor || ''} ${row.goodsColorEn || ''}`"
          />
        </div>
      </template>
      <template v-slot:displayNo="{ row }">
        <div class="m-0">
          <TableLabel
            :label="'NC'"
            labelKey="table_label_ncNo"
            :value="row.ncNo"
          />
          <TableLabel
            :label="'SKU'"
            labelKey="table_label_evgSkuNo"
            :value="row.evgSkuNo"
          />
          <TableLabel
            :label="'UPC'"
            labelKey="table_label_eanCode"
            :value="row.eanCode"
          />
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import { format, add, multiply, divideUp } from '@/libs/util.number.js'
import TableLabel from './label.vue'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { TableLabel },
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form', tools: 'toolbar_btn' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      format: (n) => format(n),
      tableColumns: tableColumns(this),
      currActivedRow: {},
      editRules: {
        inCtnQty: [
          {
            type: 'number',
            required: true,
            message: this.$l('table_message_inCtnQty') || '请输入装箱入数',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(
                  this.$l('table_message_inCtnQty_is0') || '装箱入数不能为空0'
                )
              }
            },
          },
        ],
        purchaseQty: [
          {
            type: 'number',
            required: true,
            message: this.$l('table_message_purchaseQty') || '请输入采购数量',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(
                  this.$l('table_message_purchaseQty_is0') ||
                    '采购数量不能为空0'
                )
              }
            },
          },
        ],
        purchasePrice: [
          {
            type: 'number',
            required: true,
            message: this.$l('table_message_purchasePrice') || '请输入采购单价',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(
                  this.$l('table_message_purchasePrice_is0') ||
                    '采购单价不能为空0'
                )
              }
            },
          },
        ],
      },
    }
  },
  computed: {
    footerData() {
      const totalColumnFields = this.tableColumns
        .filter((c) => c.isTotalColumn)
        .map((c) => c.field)

      const totalColumnValues = this.tableData.reduce((result, next) => {
        totalColumnFields.forEach((f) => {
          result[f] = add(result[f], next[f])
        })
        return result
      }, Object.fromEntries(totalColumnFields.map((f) => [f, 0])))

      const result = this.tableColumns
        .filter((c) => c.visible != false)
        .map((t) => {
          if (!t.isTotalColumn) return ''
          const val = totalColumnValues[t.field]
          return val ? format(val) : '0'
        })
      result[2] = this.$l('table_label_total') || '合计'
      return [result]
    },
  },
  methods: {
    editActived({ row }) {
      this.currActivedRow = { ...row }
    },
    async editClosed({ row }) {
      const res = await this.$api
        .ecomEvgPurchaseDetailUpdateApi({ ...row })
        .catch(() => null)
      const { status } = res || {}
      if (status !== 200) {
        row.inCtnQty = this.currActivedRow.inCtnQty
        row.purchaseQty = this.currActivedRow.purchaseQty
        row.purchasePrice = this.currActivedRow.purchasePrice
        setTimeout(() => {
          this.$refs.table.updateFooter()
        }, 0)
        return
      }

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      const { purchasePrice, purchaseQty, inCtnQty } = row
      row.subAmount = multiply(purchasePrice, purchaseQty)
      row.ctnQty = divideUp(purchaseQty, inCtnQty, 0)

      this.$emit('edit-reload')
      setTimeout(() => {
        this.$refs.table.updateFooter()
      }, 0)
    },
    async edit(row) {
      this.$refs.table.setActiveRow(row)
    },
    async del({ evgPurchaseDetailCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_deleteSku') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomEvgPurchaseDetailDelApi({ evgPurchaseDetailCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
      this.$emit('edit-reload')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    > div {
      margin-top: 7px;
    }
  }
  .vxe-table--render-default .vxe-body--row:first-child .vxe-cell--valid {
    top: initial;
    padding-top: 4px;
  }
  .col-opt {
    padding-top: 0 !important;
  }
  .col--seq {
    padding-top: 11px !important;
  }
}
</style>
